// Shared vocabulary for the whole-home (multi-room) customer journey.

export const PROPERTY_TYPES = [
  { value: "flat", label: "Flat" },
  { value: "house", label: "House" },
  { value: "bungalow", label: "Bungalow" },
  { value: "other", label: "Other" },
];

export const ROOM_TYPES = [
  "Living room", "Dining room", "Bedroom", "Hallway", "Landing", "Stairs",
  "Kitchen", "Bathroom", "Utility room", "Office", "Other",
];

// Full named-room vocabulary for the "Your flooring plan" dropdown.
export const ROOM_NAMES = [
  "Lounge", "Dining room", "Kitchen", "Kitchen/diner",
  "Main bedroom", "Bedroom 1", "Bedroom 2", "Bedroom 3", "Bedroom 4",
  "Guest bedroom", "Children's bedroom",
  "Hall", "Stairs", "Landing",
  "Bathroom", "En-suite", "WC", "Utility room",
  "Home office", "Playroom", "Conservatory",
];

// Stairs are never treated as a plain rectangle — a fitter confirms them.
export const STAIRS_NAMES = ["stairs"];

export const FLOORING_OPTIONS = [
  { value: "carpet", label: "Carpet" },
  { value: "vinyl", label: "Vinyl" },
  { value: "laminate", label: "Laminate" },
  { value: "lvt", label: "LVT" },
  { value: "carpet_tiles", label: "Carpet tiles" },
  { value: "open", label: "Open to suggestions" },
];

export const COLOUR_OPTIONS = [
  "Any colour", "Beige/cream", "Grey", "Brown", "Black", "White",
  "Natural/wood effect", "Stone effect", "Patterned", "Other",
];

export const TEXTURE_OPTIONS = [
  "Any finish", "Soft/plush", "Twist", "Loop", "Saxony",
  "Wood effect", "Stone effect", "Smooth", "Textured",
];

export const STYLE_GOALS = [
  { value: "similar", label: "Similar flooring throughout" },
  { value: "coordinating", label: "Coordinating colours" },
  { value: "best_saving", label: "Best saving for each room" },
  { value: "none", label: "No preference" },
];

export const SERVICE_OPTIONS = [
  {
    value: "collect_self",
    title: "Collect it myself",
    body: "I'll collect the flooring from the retailer.",
  },
  {
    value: "collection_delivery",
    title: "Collection and delivery",
    body: "A suitable local partner collects the flooring and delivers it to me.",
  },
  {
    value: "fitting",
    title: "Fitting only",
    body: "The flooring is already at the property and I need a professional to fit it.",
  },
  {
    value: "collection_delivery_fitting",
    title: "Collection, delivery and fitting",
    body: "A local flooring professional collects the flooring, delivers it and installs it.",
  },
];

// Colour preference → default flooring type isn't inferred; used only for prompts.
export const DEFAULT_ROOM = () => ({
  id: (crypto?.randomUUID?.() || String(Math.random()).slice(2)),
  name: "Room 1",
  width_m: "",
  length_m: "",
  flooring_type: "carpet",
  budget_gbp: "",
  colour: "",
  texture: "",
  notes: "",
  is_stairs: false,
});
